import {
  collection,
  query,
  orderBy,
  limit,
  getDocs,
  where,
  Timestamp,
  type QueryConstraint,
} from 'firebase/firestore';
import { db } from '../firebase';
import type { MktEvent, MktEventType } from '@shared/types';

export interface AuditLogFilters {
  event_type?: MktEventType | 'all';
  tenant_id?: string;
  since?: Date;
  until?: Date;
  max?: number;
}

export async function queryAuditLog(filters: AuditLogFilters = {}): Promise<MktEvent[]> {
  const constraints: QueryConstraint[] = [];
  if (filters.event_type && filters.event_type !== 'all') {
    constraints.push(where('event_type', '==', filters.event_type));
  }
  if (filters.tenant_id) {
    constraints.push(where('tenant_id', '==', filters.tenant_id));
  }
  if (filters.since) {
    constraints.push(where('timestamp', '>=', Timestamp.fromDate(filters.since)));
  }
  if (filters.until) {
    constraints.push(where('timestamp', '<=', Timestamp.fromDate(filters.until)));
  }
  constraints.push(orderBy('timestamp', 'desc'));
  constraints.push(limit(filters.max ?? 100));

  const q = query(collection(db, 'mkt_events'), ...constraints);
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ ...(d.data() as Omit<MktEvent, 'id'>), id: d.id }) as MktEvent);
}
